// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"da126437","239":"54b50c9c","455":"198e8e78"}[chunkId] + ".chunk.js";
};